import { Button, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';

import { CustomTableActionType } from '../types';

interface IActionButtonCustom {
    action: CustomTableActionType;
    data: any;
    dataRaw: any;
}

const ActionButtonCustom: React.FC<IActionButtonCustom> = ({ action, data, dataRaw }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {}, [isOpen]);

    const _showModal = () => {
        setIsOpen(true);
    };

    const accessEdit = action.accessToButton?.(dataRaw);

    return (
        <>
            {accessEdit && (
                <Tooltip title={action.hint}>
                    <Button
                        shape="circle"
                        icon={action.icon}
                        type={'default'}
                        color={action.colorButton || 'default'}
                        onClick={() => action.callback(data, dataRaw)}
                    />
                </Tooltip>
            )}
        </>
    );
};

export default ActionButtonCustom;
